import _objectWithoutProperties from "/workdir/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styles from '../../ActionList.scss.js';
import { Item } from '../Item/Item.js';

function Section(_ref) {
  var section = _ref.section,
      hasMultipleSections = _ref.hasMultipleSections,
      actionRole = _ref.actionRole,
      onActionAnyItem = _ref.onActionAnyItem;

  var handleAction = function handleAction(itemOnAction) {
    return function () {
      if (itemOnAction) {
        itemOnAction();
      }

      if (onActionAnyItem) {
        onActionAnyItem();
      }
    };
  };

  var actionMarkup = section.items.map(function (_ref2, index) {
    var content = _ref2.content,
        helpText = _ref2.helpText,
        onAction = _ref2.onAction,
        item = _objectWithoutProperties(_ref2, ["content", "helpText", "onAction"]);

    return /*#__PURE__*/React.createElement("li", {
      key: "".concat(content, "-").concat(index),
      role: actionRole === 'menuitem' ? 'presentation' : undefined
    }, /*#__PURE__*/React.createElement(Item, Object.assign({
      content: content,
      helpText: helpText,
      role: actionRole,
      onAction: handleAction(onAction)
    }, item)));
  });
  var className = section.title ? undefined : styles['Section-withoutTitle'];
  var titleMarkup = section.title ? /*#__PURE__*/React.createElement("p", {
    className: styles.Title
  }, section.title) : null;
  var sectionRole;

  switch (actionRole) {
    case 'option':
      sectionRole = 'presentation';
      break;

    case 'menuitem':
      sectionRole = !hasMultipleSections ? 'menu' : 'presentation';
      break;

    default:
      sectionRole = undefined;
      break;
  }

  var sectionMarkup = /*#__PURE__*/React.createElement("div", {
    className: className
  }, titleMarkup, /*#__PURE__*/React.createElement("ul", {
    className: styles.Actions,
    role: sectionRole,
    tabIndex: !hasMultipleSections ? -1 : undefined
  }, actionMarkup));
  return hasMultipleSections ? /*#__PURE__*/React.createElement("li", {
    className: styles.Section,
    role: "presentation"
  }, sectionMarkup) : sectionMarkup;
}

export { Section };